import { Injectable } from "@angular/core";

import { CommonState } from "../state";

import { Nationality } from "./nationality.model";

/**
 * @deprecated [fabric-deprecated] - use fabric ContentService from svc-content instead
 */
@Injectable({
	providedIn: "root",
})
export class NationalitySelector {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentServiceValue.GetAllNationalities)" instead
	 */
	getNationalities() {
		return (state: CommonState): Nationality[] | undefined =>
			state.nationality.nationalities?.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
	}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentServiceValue.GetNationalityByCode, { value: string })" instead
	 */
	getNationalityByCode(nationalityCode: string) {
		return (state: CommonState): Nationality | undefined =>
			state.nationality.nationalities?.find(
				(nationality) => nationality.value.toUpperCase() === nationalityCode.toUpperCase()
			);
	}
}
